import { Typography } from 'components/generic/typography';
import { ArticleHeaderFromContextProps } from '../shared/types';

export default function Title({ title, ...restProps }: { title: ArticleHeaderFromContextProps['title'] }) {
    return (
        <Typography.Headline size="L" {...restProps}>
            {title}
        </Typography.Headline>
    );
}
